export const paginationOptions = {
  rowsPerPageText: "Linhas por Página",
  rangeSeparatorText: "de",
  selectAllRowsItemText: "Todos",
  selectAllRowsItem: true,
  paginationRowsPerPageOptions: [20, 25, 30],
};
export const columns = [
  {
    name: "NOME",
    selector: (row) => `${row.nomeCredor}`,
    sortable: true,
    wrap: true,
  },
  {
    name: "DESTINO",
    selector: (row) => `${row.localidade}`,
    sortable: true,
    wrap: true,
  },
  {
    name: "D.CONC.",
    selector: (row) => `${row.quantidadeDiarias}`,
    sortable: true,
    wrap: true
  },

  {
    name: "V.RECEBIDO",
    selector: (row) => `${row.valor}`,
    sortable: true,
    right: true,
  },
  {
    name: "FINALIDADE",
    selector: (row) => `${row.motivo}`,
    sortable: true,
    grow: 4,
    wrap: true,
  },
  {
    name: "CARGO",
    selector: (row) => `${row.cargo}`,
    sortable: true,
    wrap: true,
  },
  {
    name: "ORGÂO",
    selector: (row) => `${row.descUnidadeOrcamentaria}`,
    sortable: true,
    wrap: true,
  },
//   {
//     name: "MATRICULA",
//     selector: (row) => `${row.matricula}`,
//     sortable: true,
//   },
  {
    name: "SAIDA",
    selector: (row) => `${row.dataInicio}`,
    sortable: true,
  },
  {
    name: "RETORNO",
    selector: (row) => `${row.dataRetorno}`,
    sortable: true,
  },


];
